import React from 'react'
import RowItem from './item'
import { ITEM_TYPES } from '@/constants'

export const TREE_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external'
}

export const prepareTreeData = (input, actions, localize, locale) => {
  const processRows = (treeType, items) => {
    if (items && items.length > 0) {
      return items.map(item => {
        return {
          title: (
            <RowItem
              title={item.title}
              id={item.id}
              type={(item.itemType === ITEM_TYPES.CHAPTER ? 'chapter' : 'document')}
              treeType={treeType}
              actions={actions}
              localize={localize}
              locale={locale}
              file={item.file}
            />
          ),
          children: processRows(treeType, item.children),
          expanded: item.expanded
        }
      })
    }
    return null
  }

  const data = {}
  data[TREE_TYPES.INTERNAL] = []
  data[TREE_TYPES.EXTERNAL] = []

  if (input) {
    [TREE_TYPES.INTERNAL, TREE_TYPES.EXTERNAL].forEach(type => {
      if (input[type]) {
        const rows = processRows(type, input[type])
        if (rows) { rows.forEach(row => data[type].push(row)) }
      }
    })
  }
  return data
}

export const processTreeData = (treeData) => {
  const processRows = (items) => {
    if (items && items.length > 0) {
      return items.map(item => {
        return {
          title: item.title.props.title,
          id: item.title.props.id,
          itemType: (item.title.props.type === 'chapter' ? ITEM_TYPES.CHAPTER : ITEM_TYPES.DOCUMENT),
          file: item.title.props.file,
          children: processRows(item.children),
          expanded: item.expanded
        }
      })
    }
    return null
  }

  return processRows(treeData)
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/dataSource/index.js